import { useState, useEffect } from 'react';

export default function useSearch(optionsList = []) {
  const [searchValue, setSearchValue] = useState('');
  const [searchedOptions, setSearchedOptions] = useState(optionsList);

  useEffect(() => {
    const updatedOptionsList = searchValue
      ? optionsList.filter(({ label }) => label.toLocaleString().indexOf(searchValue) === 0)
      : optionsList;
    setSearchedOptions(updatedOptionsList);
  }, [optionsList, searchValue]);

  return [searchValue, setSearchValue, searchedOptions];
}
